import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
  // styles: [
  //   `

  //   `,
  // ],
})
export class InventoryComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
